import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ToastService } from '../l_admin/toast.service';
import { ToastEvent } from '../l_admin/models/toast-event';
import { EventTypes } from '../l_admin/models/event-types';
import { Subscription } from 'rxjs';



declare var intlTelInput: {
  (element: HTMLElement, options?: {
    initialCountry?: string;
    separateDialCode?: boolean;
    loadUtilsOnInit?: boolean; // Gantikan utilsScript dengan loadUtilsOnInit
    // Tambahkan opsi lain sesuai kebutuhan
  }): any;
};

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;

  private intlTelInputInstance: any;
  isPasswordVisible = false;
  isPasswordChange: boolean = false;

  hasCurrentPassword : boolean = false;


  profileImage: string | null = null;

  isDisabled: boolean = false;
  accountForm: FormGroup;
  isPhoneDisabled: boolean = true;

  isLoading = false;
  error: string | null = null;
  id_pelanggan : number | null = null;

  isPhoneAdded: boolean = false;

  submitted = false;
  EventTypes = EventTypes;

  toasts: ToastEvent[] = [];
  private toastSubscription: Subscription;

  constructor(
    private fb: FormBuilder, 
    public authService: AuthService, 
    private router: Router,
    private toastService: ToastService,
    private location: Location
  ) {
    // Initialize form with validation
    this.accountForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: [
        { value: '', disabled: this.isPhoneDisabled },
        [Validators.required, Validators.pattern(/^\d{10,15}$/)]
      ],
      oldPassword: [''],
      newPassword: [''],
      confirmPassword: ['']
    },{

      validator: this.passwordMatchValidator.bind(this)
    });

    this.toastSubscription = this.toastService.toastEvents.subscribe(
      (event: ToastEvent) => {
        this.toasts = [...this.toasts, event];
        setTimeout(() => {
          this.toasts = this.toasts.filter(t => t !== event);
        }, 3000);
      }
    );

  }

  ngOnInit(): void {

    this.isDisabled = false;

    this.loadAccountData();

  }



  private setPhoneNumber(fullPhoneNumber: string) {
    if (!this.intlTelInputInstance) return;

    this.intlTelInputInstance.setNumber(fullPhoneNumber); // Set nomor ke input

    const countryData = this.intlTelInputInstance.getSelectedCountryData();
    
    if (!countryData || !countryData.dialCode) {
        console.warn("Gagal mendapatkan data negara dari intlTelInput.");
        return;
    }

    const dialCode = `+${countryData.dialCode}`;

    // Hindari kesalahan dengan memastikan bahwa nomor berisi kode negara
    let phoneWithoutDialCode = fullPhoneNumber.startsWith(dialCode)
        ? fullPhoneNumber.replace(dialCode, '').trim()
        : fullPhoneNumber;

    // Update nilai input tanpa kode negara
    this.accountForm.patchValue({
        phone: phoneWithoutDialCode
    });

    // console.log("intlTelInputInstance:", this.intlTelInputInstance);
}

  


  loadAccountData(): void {
    const userEmail = localStorage.getItem('user_email');
    if (!userEmail) return;
    this.authService.getPelangganByEmail(userEmail).subscribe(
      (data) => {
        this.id_pelanggan = data.id;
        let no : string = '';
        if (!data.verification_code)
        {
          if (!data.whatsapp_number)
          {
            no = '';
            this.isPhoneAdded = false;
          }
          else
          {
            no = data.whatsapp_number;
            this.isPhoneAdded = true;
            localStorage.setItem('user_wa', data.whatsapp_number);
          }
         
        } 
        else
        {
          no = '';
          this.isPhoneAdded = false;
        }

        // console.log(no);

        // Gunakan patchValue untuk mengisi data ke dalam form
        this.accountForm.patchValue({
          name: data.nama_pelanggan || '',
          email: data.email_pelanggan || ''
        });

        this.initializePhoneInput();
        this.setPhoneNumber(no);




        // Jika ada gambar profil
        if (data.foto) {
          this.profileImage = data.foto;
        }
      },
      (error) => {
        console.error('Error loading account data:', error);
      }
    );
  }


  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Validate file size (3MB limit)
      if (file.size > 3 * 1024 * 1024) {
        alert('File size exceeds 3MB. Please choose a smaller file.');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.profileImage = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  }


  private initializePhoneInput() {
    if (this.phoneInput && (window as any).intlTelInput) {
        const input = this.phoneInput.nativeElement;

        if (this.intlTelInputInstance) {
            this.intlTelInputInstance.destroy();
        }

        this.intlTelInputInstance = intlTelInput(input, {
            initialCountry: 'id',
            separateDialCode: true,
            loadUtilsOnInit: true // Menghapus utilsScript yang sudah deprecated
        });
    }
  }

  addPhoneNumber() {
    this.navigateToPhoneNumber('add');
  }

  enablePhoneInput() {
    this.isPhoneDisabled = false;
    this.accountForm.get('phone')?.enable();
  }


  removeToast(toast: ToastEvent): void {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  onSubmit() {
      this.submitted = true;
      this.isLoading = true;


      if (this.accountForm.valid) {
        const formData = new FormData();
    
        // Append form data
        formData.append('name', this.accountForm.get('name')?.value || '');
        formData.append('email', this.accountForm.get('email')?.value || '');
        formData.append('phone', this.accountForm.get('phone')?.value || '');
    
        // Append password fields only if changing password
        if (this.isPasswordChange) {
          formData.append('oldPassword', this.accountForm.get('oldPassword')?.value || '');
          formData.append('newPassword', this.accountForm.get('newPassword')?.value || '');
        }
    
        // Append profile image if available
        if (this.profileImage) {
          const fileInput = document.getElementById('imageUpload') as HTMLInputElement;
          if (fileInput && fileInput.files && fileInput.files[0]) {
            formData.append('profileImage', fileInput.files[0]);
          }
        }


        const pelangganId = this.id_pelanggan;

        if (pelangganId)
        {
          this.authService.updatePelanggan(pelangganId, formData).subscribe(
            (response) => {
              this.router.navigate(['/account']);
              this.toastService.showSuccessToast(
                'Success',
                'Your profile updated successfully!'
              );
              this.toastService.clearSessionToast();
              this.isLoading = false;
              this.submitted = false;
              this.loadAccountData();
              // this.togglePasswordChange(new Event('submit'));

              this.accountForm.patchValue({
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
              });

              if ($('#changePassword').is(':checked')) {
                $('#changePassword').trigger('click');
              }

      
              localStorage.setItem('user_photo', response.fotoPath || '');

            },
            (error) => {
              console.error('Error saat mengupdate pelanggan:', error);
              this.toastService.showErrorToast(
                'Error',
                 error
              );
              this.toastService.clearSessionToast();
              this.isLoading = false;
              this.submitted = false;
            }
          );
        }




     
    }
 }

  // Helper to access form controls
  get f() {
    return this.accountForm.controls;
  }


  validateCurrentPassword() {
    // Ambil nilai current password dari form
    const oldPassword = this.accountForm.get('oldPassword')?.value;
    // Pastikan kita memiliki id user yang aktif, misalnya dari currentUser
    const userId = this.id_pelanggan || 0;
  
    // Jika tidak memiliki password di database, tidak perlu validasi
    if (!this.hasCurrentPassword) {
      return;
    }
  
    // Panggil service untuk validasi password lama
    this.authService.validateOldPassword(userId, oldPassword).subscribe(
      (response) => {
        if (!response.valid) {
          // Jika validasi gagal, set error invalidOldPassword
          this.accountForm.get('oldPassword')?.setErrors({ invalidOldPassword: true });
        } else {
          // Jika validasi sukses, pastikan error sebelumnya dihapus
          this.accountForm.get('oldPassword')?.setErrors(null);
        }
      },
      (error) => {
        // Jika terjadi error pada request, set error invalidOldPassword
        this.accountForm.get('oldPassword')?.setErrors({ invalidOldPassword: true });
      }
    );
  }


  validateOldPassword(control: AbstractControl) {
    const userId = this.id_pelanggan || 0;
    if (!control.value) return of(null); // Jika kosong, validasi lainnya akan menangani

    return this.authService.validateOldPassword(userId, control.value).pipe(
      map((response) => (response.valid ? null : { invalidOldPassword: true })),
      catchError(() => of({ invalidOldPassword: true })) // Jika gagal, anggap tidak valid
    );
  }

  passwordMatchValidator(formGroup: FormGroup): void {
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
  
    if (newPassword !== confirmPassword) {
      formGroup.get('confirmPassword')?.setErrors({ mismatch: true });
    } else {
      formGroup.get('confirmPassword')?.setErrors(null);
    }
  }

  passwordValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.value;
    if (!password) {
      return null;
    }
  
    // Periksa apakah password memiliki huruf besar dan angka
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
  
    if (!hasUpperCase || !hasNumber) {
      return { passwordStrength: true };
    }
    return null;
  }


  checkCurrentPassword(email_pelanggan : string) {

    this.authService.getPelangganPass(email_pelanggan).subscribe((response: any) => {
      if (response.pass_pelanggan) {
        this.hasCurrentPassword = true;
        this.accountForm.get('oldPassword')?.setValidators([Validators.required]);
        this.accountForm.get('oldPassword')?.setAsyncValidators([this.validateOldPassword.bind(this)]);
      } else {
        this.hasCurrentPassword = false;
        this.accountForm.get('oldPassword')?.clearValidators();
      }
      this.accountForm.get('oldPassword')?.updateValueAndValidity();
    });
  }



  togglePasswordChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.isPasswordChange = checkbox.checked;

    if (this.isPasswordChange) {
      // Tambahkan validasi untuk password lama
      // this.accountForm.get('oldPassword')?.setValidators([Validators.required]);
      // this.accountForm.get('oldPassword')?.setAsyncValidators([this.validateOldPassword.bind(this)]);

      const userEmail = localStorage.getItem('user_email');
      if (!userEmail) return;
      this.checkCurrentPassword(userEmail);

      // Tambahkan validasi untuk password baru dan konfirmasi password
      this.accountForm.get('newPassword')?.setValidators([Validators.required, this.passwordValidator]);
      this.accountForm.get('confirmPassword')?.setValidators([Validators.required]);

      // Perbarui validasi
      // this.accountForm.get('oldPassword')?.updateValueAndValidity();
      this.accountForm.get('newPassword')?.updateValueAndValidity();
      this.accountForm.get('confirmPassword')?.updateValueAndValidity();
    } else {
      // Hapus validasi jika opsi "Change Password" tidak dipilih
      this.accountForm.get('oldPassword')?.clearValidators();
      this.accountForm.get('oldPassword')?.clearAsyncValidators();
      this.accountForm.get('newPassword')?.clearValidators();
      this.accountForm.get('confirmPassword')?.clearValidators();

      // Perbarui validasi
      this.accountForm.get('oldPassword')?.updateValueAndValidity();
      this.accountForm.get('newPassword')?.updateValueAndValidity();
      this.accountForm.get('confirmPassword')?.updateValueAndValidity();
    }
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onImageError(): void {
    this.profileImage = null; // Menghapus gambar jika terjadi error
  }
  editPhoneNumber(): void{
    this.navigateToPhoneNumber('edit');
  }


  navigateToPhoneNumber(mode: 'add' | 'edit'): void {
    this.router.navigate(['/account/phone-number'], { state: { mode } });
  }
}
